// @flow

import * as React from 'react';
import {ButtonLink} from 'sail/Button';
import {MenuItem, OverflowMenu} from 'sail/Menu';
import Group from 'sail/Group';
import {useArticle} from 'docs/data';

import type {XRayMode} from './XRayMode';

type XRayToggleProps = {|
  mode: XRayMode,
  setMode: (value: XRayMode) => any,
|};

export const XRayToggle = ({mode, setMode}: XRayToggleProps) => {
  const {isLoading} = useArticle();

  const icon = mode === 'xray' ? 'arrowDown' : 'arrowUp';

  let label;
  if (isLoading) {
    label = 'Loading';
  } else {
    label = mode === 'xray' ? 'Hide X-Ray' : 'Show X-Ray';
  }

  return (
    <Group
      background="gray50"
      direction="horizontal"
      alignItems="center"
      justifyContent="space-between"
      padding={{vertical: 12, horizontal: 20}}
      divider={{color: 'light', width: 1, side: 'all'}}
    >
      <ButtonLink
        size="medium"
        color="gray"
        icon={icon}
        label={label}
        pending={isLoading}
        onClick={() => {
          if (!isLoading) {
            setMode(mode === 'xray' ? 'normal' : 'xray');
          }
        }}
      />
      <OverflowMenu
        hoverable
        size="small"
        contextMeetingPoint="top"
        layerMeetingPoint="bottom"
      >
        <MenuItem onClick={() => setMode('disabled')}>
          Disable until refresh
        </MenuItem>
      </OverflowMenu>
    </Group>
  );
};
